import { render, staticRenderFns } from "./LoanOverdueCard.vue?vue&type=template&id=10703172&scoped=true&"
import script from "./LoanOverdueCard.vue?vue&type=script&lang=ts&"
export * from "./LoanOverdueCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10703172",
  null
  
)

export default component.exports